import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-google', 'IconBrandGoogle', [
  ['path', { d: 'M17.788 5.108a9 9 0 1 0 3.212 6.892h-8', key: 'svg-0' }],
]);
